export function wholesalerUsesContractTerm(wholesalers, accountNumber) {
  if (!accountNumber) return false;
  const wholesaler = wholesalers?.find(
    w => Number(w.accountNumber) === Number(accountNumber)
  );
  return wholesaler?.useContractTerm === true;
}
